import React, { useState } from 'react';
import { IconType } from 'react-icons';
import { FaWhatsapp } from 'react-icons/fa';
import {
  MdArrowForward, MdCheck, MdOutlineAdminPanelSettings, MdOutlineCalendarMonth,
  MdOutlineFileDownload, MdOutlineHowToReg, MdOutlineMailOutline,
  MdOutlinePhoneIphone, MdOutlineSell, MdOutlineSync, MdPix
} from 'react-icons/md';

import CadastroModal from './CadastroModal';
import PreviaSistema from './PreviaSistema';
import { LINK_WHATSAPP } from './constants';
import tifirelogo from '../../assets/images/tifire.ico';

interface IRecurso {
  icone: IconType;
  titulo: string;
  descricao: string;
  itens?: string[];
}

const recursosPrincipais: IRecurso[] = [
  {
    icone: MdOutlineCalendarMonth,
    titulo: 'Agenda online dos espaços',
    descricao: 'O associado vê as datas livres e reserva churrasqueiras, salões e quiosques pelo celular, sem ligar para a secretaria.',
    itens: ['Disponibilidade em tempo real', 'Fotos e detalhes de cada espaço', 'Antecedência mínima configurável']
  },
  {
    icone: MdPix,
    titulo: 'Pagamento via Pix e cartão',
    descricao: 'A reserva só é confirmada depois do pagamento. O dinheiro cai direto na conta do clube pela Pagar.me.',
    itens: ['Confirmação automática', 'Sem duas reservas na mesma data', 'Aviso por e-mail a cada pagamento']
  },
  {
    icone: MdOutlineHowToReg,
    titulo: 'Portaria e convidados',
    descricao: 'O associado cadastra a lista de convidados e a portaria faz o check-in e o controle de entrega e devolução do espaço.',
    itens: ['Limite de convidados por reserva', 'Venda de convidados adicionais', 'Aceite de entrada e saída do kit']
  }
];

const recursosSecundarios: IRecurso[] = [
  {
    icone: MdOutlineSell,
    titulo: 'Preços flexíveis',
    descricao: 'Valor por dia da semana e datas especiais, como feriados.'
  },
  {
    icone: MdOutlineAdminPanelSettings,
    titulo: 'Perfis de acesso',
    descricao: 'Associado, administrador, assistente e portaria.'
  },
  {
    icone: MdOutlineSync,
    titulo: 'Integração de associados',
    descricao: 'Sincronize o cadastro com o sistema que o clube já usa.'
  },
  {
    icone: MdOutlineFileDownload,
    titulo: 'Relatórios em Excel',
    descricao: 'Exporte as reservas do período com um clique.'
  },
  {
    icone: MdOutlineMailOutline,
    titulo: 'Avisos por e-mail',
    descricao: 'A administração recebe cada reserva paga e cada conferência.'
  },
  {
    icone: MdOutlinePhoneIphone,
    titulo: 'Feito para o celular',
    descricao: 'Associado entra só com o CPF, sem senha para lembrar.'
  }
];

const passos = [
  { titulo: 'Cadastre o clube', descricao: 'Crie a conta, cadastre os espaços, fotos e a tabela de preços.' },
  { titulo: 'Associado reserva e paga', descricao: 'Ele escolhe o espaço e a data, paga com Pix ou cartão e a data fica garantida.' },
  { titulo: 'Portaria confere', descricao: 'No dia, a portaria faz o check-in dos convidados e registra a entrega do espaço.' }
];

const espacos = ['Churrasqueiras', 'Salões de festa', 'Quiosques', 'Quadras', 'Piscinas', 'Chalés'];

const perguntas = [
  {
    pergunta: 'Os associados precisam criar senha?',
    resposta: 'Não. O associado entra apenas com o CPF. Senha é exigida só para administradores, assistentes e portaria.'
  },
  {
    pergunta: 'Como o clube recebe os pagamentos?',
    resposta: 'Pela sua própria conta Pagar.me, com Pix ou cartão de crédito. A reserva é confirmada automaticamente quando o pagamento é aprovado.'
  },
  {
    pergunta: 'Consigo reservar em nome de um associado?',
    resposta: 'Sim. Administradores e assistentes podem fazer reservas para qualquer associado, sem passar pelo pagamento online.'
  },
  {
    pergunta: 'Preciso instalar alguma coisa?',
    resposta: 'Não. O sistema funciona no navegador do computador e do celular. Seu clube ganha um endereço próprio para os associados acessarem.'
  }
];

const classeBotaoPrimario = 'inline-flex h-12 items-center justify-center gap-2 rounded-xl bg-zinc-900 px-6 font-semibold text-white transition-colors hover:bg-zinc-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-zinc-900 focus-visible:ring-offset-2';
const classeBotaoWhatsapp = 'inline-flex h-12 items-center justify-center gap-2 rounded-xl border border-zinc-200 bg-white px-6 font-semibold text-zinc-900 transition-colors hover:border-zinc-300 hover:bg-zinc-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-zinc-900 focus-visible:ring-offset-2';

export default function Home() {
  const [modalVisible, setModalVisible] = useState(false);

  function abrirCadastro() {
    setModalVisible(true);
  }

  return (
    <div className='min-h-screen bg-white text-zinc-900'>
      <CadastroModal isOpen={modalVisible} onClose={() => setModalVisible(false)} />

      <header className='fixed inset-x-0 top-0 z-50 h-14 border-b border-zinc-200 bg-white/90 backdrop-blur'>
        <div className='mx-auto flex h-full max-w-6xl items-center justify-between gap-3 px-4'>
          <a href='#inicio' className='flex min-w-0 items-center gap-2.5 rounded-lg focus:outline-none focus-visible:ring-2 focus-visible:ring-zinc-900'>
            <img src='https://tifire.com/assets/img/fogo2.png' alt='' className='h-8 w-8 flex-none object-contain' />
            <span className='truncate font-semibold'>Agenda para Clubes</span>
          </a>
          <nav className='flex items-center gap-2'>
            <a href='#recursos' className='hidden rounded-lg px-3 py-2 text-sm text-zinc-600 hover:text-zinc-900 md:block'>Recursos</a>
            <a href='#como-funciona' className='hidden rounded-lg px-3 py-2 text-sm text-zinc-600 hover:text-zinc-900 md:block'>Como funciona</a>
            <a href='#duvidas' className='hidden rounded-lg px-3 py-2 text-sm text-zinc-600 hover:text-zinc-900 md:block'>Dúvidas</a>
            <button
              type='button'
              onClick={abrirCadastro}
              className='ml-1 h-9 rounded-lg bg-zinc-900 px-4 text-sm font-semibold text-white transition-colors hover:bg-zinc-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-zinc-900 focus-visible:ring-offset-2'
            >
              Criar conta
            </button>
          </nav>
        </div>
      </header>

      <main id='inicio' className='pt-14'>
        {/* Hero */}
        <section className='relative overflow-hidden border-b border-zinc-100 bg-gradient-to-b from-zinc-50 to-white'>
          <div className='mx-auto grid max-w-6xl items-center gap-16 px-4 pb-20 pt-12 md:grid-cols-[1.1fr_1fr] md:pb-24 md:pt-20'>
            <div className='animate-slide-up motion-reduce:animate-none'>
              <span className='inline-flex items-center gap-2 rounded-full border border-zinc-200 bg-white px-3 py-1 text-xs font-medium text-zinc-600'>
                <span className='h-1.5 w-1.5 rounded-full bg-emerald-500' />
                Para clubes e associações
              </span>
              <h1 className='mt-5 text-4xl font-semibold leading-[1.1] tracking-tight md:text-5xl'>
                Reservas do seu clube, pagas e confirmadas sem a secretaria.
              </h1>
              <p className='mt-5 max-w-xl text-lg leading-relaxed text-zinc-600'>
                O associado escolhe o espaço, paga com Pix ou cartão e a data fica garantida.
                A portaria confere os convidados e você acompanha tudo em uma agenda só.
              </p>
              <div className='mt-8 flex flex-col gap-3 sm:flex-row'>
                <button type='button' onClick={abrirCadastro} className={classeBotaoPrimario}>
                  Criar conta do clube
                  <MdArrowForward className='h-5 w-5' aria-hidden='true' />
                </button>
                <a href={LINK_WHATSAPP} target='_blank' rel='noreferrer' className={classeBotaoWhatsapp}>
                  <FaWhatsapp className='h-5 w-5 text-emerald-600' aria-hidden='true' />
                  Falar no WhatsApp
                </a>
              </div>
              <ul className='mt-8 flex flex-wrap gap-x-6 gap-y-2 text-sm text-zinc-500'>
                {['Pix e cartão', 'Associado entra só com CPF', 'Funciona no celular'].map(item => (
                  <li key={item} className='flex items-center gap-1.5'>
                    <MdCheck className='h-4 w-4 text-emerald-600' aria-hidden='true' />
                    {item}
                  </li>
                ))}
              </ul>
            </div>
            <PreviaSistema />
          </div>
        </section>

        {/* Tipos de espaço */}
        <section aria-label='Espaços atendidos' className='border-b border-zinc-100'>
          <div className='mx-auto flex max-w-6xl flex-col items-center gap-4 px-4 py-8 md:flex-row md:justify-between'>
            <p className='text-sm text-zinc-500'>Organize a reserva de qualquer espaço:</p>
            <ul className='flex flex-wrap justify-center gap-2'>
              {espacos.map(espaco => (
                <li key={espaco} className='rounded-full bg-zinc-100 px-3 py-1.5 text-sm text-zinc-700'>{espaco}</li>
              ))}
            </ul>
          </div>
        </section>

        {/* Recursos */}
        <section id='recursos' className='scroll-mt-14'>
          <div className='mx-auto max-w-6xl px-4 py-20 md:py-24'>
            <div className='max-w-2xl'>
              <p className='text-sm font-semibold uppercase tracking-wider text-zinc-500'>Recursos</p>
              <h2 className='mt-2 text-3xl font-semibold tracking-tight md:text-4xl'>
                Da reserva à portaria, tudo no mesmo lugar.
              </h2>
              <p className='mt-4 text-zinc-600'>
                Chega de caderno, planilha e reserva duplicada. O sistema cuida do fluxo inteiro.
              </p>
            </div>

            <div className='mt-12 grid gap-4 md:grid-cols-3'>
              {recursosPrincipais.map(({ icone: Icone, titulo, descricao, itens }) => (
                <article key={titulo} className='flex flex-col rounded-2xl border border-zinc-200 bg-white p-6 shadow-card'>
                  <span className='flex h-11 w-11 items-center justify-center rounded-xl bg-zinc-900 text-white'>
                    <Icone className='h-6 w-6' aria-hidden='true' />
                  </span>
                  <h3 className='mt-5 text-lg font-semibold'>{titulo}</h3>
                  <p className='mt-2 text-sm leading-relaxed text-zinc-600'>{descricao}</p>
                  {itens && (
                    <ul className='mt-5 space-y-2 border-t border-zinc-100 pt-5 text-sm text-zinc-700'>
                      {itens.map(item => (
                        <li key={item} className='flex items-start gap-2'>
                          <MdCheck className='mt-0.5 h-4 w-4 flex-none text-emerald-600' aria-hidden='true' />
                          {item}
                        </li>
                      ))}
                    </ul>
                  )}
                </article>
              ))}
            </div>

            <div className='mt-4 grid gap-px overflow-hidden rounded-2xl border border-zinc-200 bg-zinc-200 sm:grid-cols-2 lg:grid-cols-3'>
              {recursosSecundarios.map(({ icone: Icone, titulo, descricao }) => (
                <div key={titulo} className='flex gap-4 bg-white p-5'>
                  <span className='flex h-10 w-10 flex-none items-center justify-center rounded-xl bg-zinc-100 text-zinc-700'>
                    <Icone className='h-5 w-5' aria-hidden='true' />
                  </span>
                  <div>
                    <h3 className='font-semibold'>{titulo}</h3>
                    <p className='mt-1 text-sm text-zinc-600'>{descricao}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Como funciona */}
        <section id='como-funciona' className='scroll-mt-14 border-y border-zinc-100 bg-zinc-50'>
          <div className='mx-auto max-w-6xl px-4 py-20 md:py-24'>
            <div className='max-w-2xl'>
              <p className='text-sm font-semibold uppercase tracking-wider text-zinc-500'>Como funciona</p>
              <h2 className='mt-2 text-3xl font-semibold tracking-tight md:text-4xl'>Seu clube no ar em três passos.</h2>
            </div>
            <ol className='mt-12 grid gap-8 md:grid-cols-3 md:gap-6'>
              {passos.map((passo, i) => (
                <li key={passo.titulo} className='relative'>
                  <div className='flex items-center gap-4'>
                    <span className='flex h-10 w-10 flex-none items-center justify-center rounded-full bg-zinc-900 font-semibold text-white'>
                      {i + 1}
                    </span>
                    {i < passos.length - 1 && <span className='hidden h-px flex-1 bg-zinc-300 md:block' aria-hidden='true' />}
                  </div>
                  <h3 className='mt-5 text-lg font-semibold'>{passo.titulo}</h3>
                  <p className='mt-2 text-sm leading-relaxed text-zinc-600 md:pr-6'>{passo.descricao}</p>
                </li>
              ))}
            </ol>
            <div className='mt-12'>
              <button type='button' onClick={abrirCadastro} className={classeBotaoPrimario}>
                Começar pelo passo 1
                <MdArrowForward className='h-5 w-5' aria-hidden='true' />
              </button>
            </div>
          </div>
        </section>

        {/* Dúvidas */}
        <section id='duvidas' className='scroll-mt-14'>
          <div className='mx-auto grid max-w-6xl gap-10 px-4 py-20 md:grid-cols-[1fr_1.4fr] md:py-24'>
            <div>
              <p className='text-sm font-semibold uppercase tracking-wider text-zinc-500'>Dúvidas</p>
              <h2 className='mt-2 text-3xl font-semibold tracking-tight md:text-4xl'>Perguntas frequentes</h2>
              <p className='mt-4 text-zinc-600'>Não achou o que procurava? Chame a gente no WhatsApp.</p>
              <a
                href={LINK_WHATSAPP}
                target='_blank'
                rel='noreferrer'
                className='mt-6 inline-flex items-center gap-2 rounded-lg font-semibold text-emerald-700 underline-offset-4 hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-zinc-900'
              >
                <FaWhatsapp className='h-5 w-5' aria-hidden='true' />
                Perguntar no WhatsApp
              </a>
            </div>
            <div className='divide-y divide-zinc-200 border-y border-zinc-200'>
              {perguntas.map(({ pergunta, resposta }) => (
                <details key={pergunta} className='group py-5'>
                  <summary className='flex cursor-pointer list-none items-center justify-between gap-4 rounded font-medium focus:outline-none focus-visible:ring-2 focus-visible:ring-zinc-900 [&::-webkit-details-marker]:hidden'>
                    {pergunta}
                    <span className='flex h-6 w-6 flex-none items-center justify-center text-xl leading-none text-zinc-400 transition-transform group-open:rotate-45 motion-reduce:transition-none' aria-hidden='true'>+</span>
                  </summary>
                  <p className='mt-3 text-sm leading-relaxed text-zinc-600'>{resposta}</p>
                </details>
              ))}
            </div>
          </div>
        </section>

        {/* Chamada final */}
        <section className='px-4 pb-20 md:pb-24'>
          <div className='mx-auto max-w-6xl overflow-hidden rounded-3xl bg-zinc-900 px-6 py-14 text-center text-white md:px-12 md:py-16'>
            <h2 className='mx-auto max-w-2xl text-3xl font-semibold tracking-tight md:text-4xl'>
              Deixe a agenda do clube trabalhar por você.
            </h2>
            <p className='mx-auto mt-4 max-w-xl text-zinc-400'>
              Cadastre seu clube agora ou fale com a gente para ver o sistema funcionando.
            </p>
            <div className='mt-8 flex flex-col justify-center gap-3 sm:flex-row'>
              <button
                type='button'
                onClick={abrirCadastro}
                className='inline-flex h-12 items-center justify-center gap-2 rounded-xl bg-white px-6 font-semibold text-zinc-900 transition-colors hover:bg-zinc-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-zinc-900'
              >
                Criar conta do clube
                <MdArrowForward className='h-5 w-5' aria-hidden='true' />
              </button>
              <a
                href={LINK_WHATSAPP}
                target='_blank'
                rel='noreferrer'
                className='inline-flex h-12 items-center justify-center gap-2 rounded-xl bg-emerald-600 px-6 font-semibold text-white transition-colors hover:bg-emerald-500 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-zinc-900'
              >
                <FaWhatsapp className='h-5 w-5' aria-hidden='true' />
                Falar no WhatsApp
              </a>
            </div>
          </div>
        </section>

      </main>

      <footer className='border-t border-zinc-200 pb-24 md:pb-0'>
        <div className='mx-auto flex max-w-6xl flex-col items-center justify-between gap-3 px-4 py-6 text-sm text-zinc-500 sm:flex-row'>
          <a href='http://tifire.com/' target='_blank' rel='noreferrer' className='flex items-center gap-2 rounded hover:text-zinc-900 focus:outline-none focus-visible:ring-2 focus-visible:ring-zinc-900'>
            <img src={tifirelogo} alt='' className='h-6 w-6' />
            TI.Fire Sistemas e Consultoria
          </a>
          <p>© {new Date().getFullYear()} Agenda para Clubes e Associações</p>
        </div>
      </footer>

      {/* WhatsApp flutuante (desktop) */}
      <a
        href={LINK_WHATSAPP}
        target='_blank'
        rel='noreferrer'
        aria-label='Falar no WhatsApp'
        className='fixed bottom-6 right-6 z-40 hidden h-14 w-14 items-center justify-center rounded-full bg-emerald-500 text-white shadow-lg transition-transform hover:scale-105 focus:outline-none focus-visible:ring-2 focus-visible:ring-zinc-900 focus-visible:ring-offset-2 motion-reduce:transition-none md:flex'
      >
        <FaWhatsapp className='h-7 w-7' aria-hidden='true' />
      </a>

      {/* Barra de ação (mobile) */}
      <div className='fixed inset-x-0 bottom-0 z-40 border-t border-zinc-200 bg-white/90 px-4 pb-[calc(0.75rem+env(safe-area-inset-bottom))] pt-3 backdrop-blur md:hidden'>
        <div className='flex gap-2'>
          <a
            href={LINK_WHATSAPP}
            target='_blank'
            rel='noreferrer'
            aria-label='Falar no WhatsApp'
            className='flex h-12 w-12 flex-none items-center justify-center rounded-xl bg-emerald-600 text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-zinc-900 focus-visible:ring-offset-2'
          >
            <FaWhatsapp className='h-6 w-6' aria-hidden='true' />
          </a>
          <button
            type='button'
            onClick={abrirCadastro}
            className='h-12 flex-1 rounded-xl bg-zinc-900 font-semibold text-white transition-colors hover:bg-zinc-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-zinc-900 focus-visible:ring-offset-2'
          >
            Criar conta do clube
          </button>
        </div>
      </div>
    </div>
  );
};
